import { useEffect, useState } from "react";
import { Menu, X, ShieldCheck } from "lucide-react";
import Logo from "./Logo";
import { openWhatsApp, DEFAULT_HELLO } from "../lib/whatsapp";

const links = [
    { label: "Inicio", href: "#inicio" },
    { label: "Portfolio", href: "#portfolio" },
    { label: "Precios", href: "#precios" },
    { label: "Productos", href: "#productos" },
    { label: "Espacio", href: "#espacio" },
    { label: "Contacto", href: "#contacto" },
];

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 32);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const goTo = (href) => (e) => {
        e.preventDefault();
        setOpen(false);
        // Portfolio link opens the fullscreen window directly.
        if (href === "#portfolio") {
            window.dispatchEvent(new Event("portfolio:open"));
            return;
        }
        const el = document.querySelector(href);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <header
            data-testid="main-navbar"
            className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
                scrolled ? "nav-blur" : "bg-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-20">
                <a
                    href="#inicio"
                    onClick={goTo("#inicio")}
                    data-testid="nav-logo"
                    className="flex items-center"
                >
                    <Logo size="sm" />
                </a>

                <nav className="hidden md:flex items-center gap-10">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            onClick={goTo(l.href)}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            className="link-underline text-[11px] tracking-[0.28em] uppercase text-[#1C1A18]/80 hover:text-[#1C1A18] font-light"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <div className="flex items-center gap-3">
                    <button
                        type="button"
                        data-testid="nav-reservar-btn"
                        onClick={() =>
                            openWhatsApp(
                                "Hola Silvia, me gustaría reservar una sesión.",
                            )
                        }
                        className="hidden md:inline-flex items-center gap-2 px-5 py-3 btn-gold text-[11px] uppercase"
                    >
                        Reservar sesión
                    </button>

                    <button
                        type="button"
                        className="p-2 text-[#1C1A18]"
                        aria-label={open ? "Cerrar menú" : "Abrir menú"}
                        data-testid="hamburger-toggle"
                        onClick={() => setOpen((o) => !o)}
                    >
                        {open ? <X size={22} /> : <Menu size={22} />}
                    </button>
                </div>
            </div>

            {/* Hamburger menu (mobile + desktop) */}
            <div
                className={`overflow-hidden transition-all duration-500 ${
                    open
                        ? "max-h-[520px] border-t border-[#e6e2db]"
                        : "max-h-0"
                } nav-blur`}
                data-testid="hamburger-menu"
            >
                <div className="px-6 py-8 flex flex-col gap-5 max-w-7xl mx-auto">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            onClick={goTo(l.href)}
                            data-testid={`hamburger-link-${l.label.toLowerCase()}`}
                            className="text-sm tracking-[0.28em] uppercase font-light text-[#1C1A18]"
                        >
                            {l.label}
                        </a>
                    ))}

                    <a
                        href="/admin"
                        data-testid="hamburger-admin-link"
                        className="mt-2 inline-flex items-center gap-2 text-sm tracking-[0.28em] uppercase font-light text-[#C4A882] hover:text-[#1C1A18] self-start"
                    >
                        <ShieldCheck size={14} /> Admin
                    </a>

                    <button
                        type="button"
                        onClick={() => {
                            setOpen(false);
                            openWhatsApp(DEFAULT_HELLO);
                        }}
                        data-testid="hamburger-reservar-btn"
                        className="md:hidden mt-2 px-5 py-3 btn-gold text-[11px] uppercase self-start"
                    >
                        Reservar sesión
                    </button>
                </div>
            </div>
        </header>
    );
}
